import { useIsPureAdmin } from '@/react/hooks/useUser';

import { Alert } from '@@/Alert';
import { Button } from '@@/buttons';
import { Link } from '@@/Link';

import {
  isInProgress,
  useActiveConnectionTest,
} from './queries/useActiveConnectionTest';
import { useClearConnectionTestMutation } from './queries/useClearConnectionTestMutation';

/** Shows the KubeSolo connection test on the Environments page until it is cleared, with a way back to it. */
export function ConnectionTestBanner() {
  const isPureAdmin = useIsPureAdmin();
  const testQuery = useActiveConnectionTest({ enabled: isPureAdmin });
  const clearMutation = useClearConnectionTestMutation();
  const test = testQuery.data;

  if (!test) {
    return null;
  }

  const inProgress = isInProgress(test);
  const checked = test.hosts.length - test.counts.queued - test.counts.running;

  return (
    <div className="row">
      <div className="col-sm-12">
        <Alert
          color="info"
          title={`KubeSolo connection test ${inProgress ? 'running' : 'finished'}`}
        >
          <div className="flex flex-wrap items-center gap-2">
            <span>
              {checked} of {test.hosts.length} checked, {test.counts.failed}{' '}
              {test.counts.failed === 1 ? 'needs' : 'need'} attention.{' '}
              <Link
                to="portainer.wizard.endpoints.create"
                params={{ envType: 'kubesolo' }}
                className="hyperlink"
                data-cy="kubesolo-test-banner-open-link"
              >
                View details
              </Link>
            </span>
            <Button
              color="default"
              disabled={clearMutation.isLoading}
              onClick={() => clearMutation.mutate(test.id)}
              data-cy="kubesolo-test-banner-clear-button"
            >
              {inProgress ? 'Cancel test' : 'Clear results'}
            </Button>
          </div>
        </Alert>
      </div>
    </div>
  );
}
